export default __webpack_public_path__ + "static/media/shareBlueWhite.b9457626.svg";